import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCompletedOnboardingUpload.meta';

export const useTrackCompletedOnboardingUpload = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedOnboardingUpload = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackCompletedOnboardingUpload };
};
